import { render, staticRenderFns } from "./KioskDetails.vue?vue&type=template&id=39f12e2a"
import script from "./KioskDetails.vue?vue&type=script&lang=ts"
export * from "./KioskDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports